<div class="main-container background-img">
  <div class="containter-fluid pl-3 pl-md-5 pt-3">
    <div class="row">
      <div class="col-3 offset-md-1">
        <a [routerLink]="['/home']" (click)="quiz.answers = []">
          <img src="../../assets/ipc-logo-rev.png" class="ipc-logo" alt="ipc logo">
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid p-3 p-md-5 mt-5 overflow-auto ">
    <div class="row pt-0">
      <div class="col-md-8 col-xl-6 col-lg-8 offset-md-1 mb-3">
        <h1 class="mt-4 mb-0 home-title">Estate Planning Questionnaire</h1>
      </div>
      <div class="col-md-5">
      </div>
    </div>
    <div class="row pt-0">
      <div class="col-md-8 col-xl-4 col-lg-8 offset-md-1">
        <!--<p class="subheading">To Move Forward with Financial Confidence</p>-->
        <P class="paragraph-text">An estate plan is a roadmap to help you transfer your assets to your beneficiaries in
          a way that meets your objectives, and allows you to provide your beneficiaries with an understanding of your
          wishes for the distribution of your assets.</P>
        <P class="paragraph-text">This questionnaire is designed to help you better understand your key goals and
          objectives when it comes to estate planning.</P>
      </div>
      <div class="col-md-5">
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-md-5 offset-md-1">
        <button class="btn btn-outline-primary" (click)="startAssessment()" [routerLink]="['question', '0']">Begin
          Questionnaire</button>
      </div>
    </div>
  </div>
  <div class="container-fluid legal-container text-center pt-5">
    <div class="row pb-2">
      <div class="col-12">
        <a class="legalprivacy" data-toggle="modal" data-target="#myModal">
          Legal & Privacy
        </a>
        <div class="modal fade" id="myModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">

              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>

              <div class="modal-body text-left">
                <p>
                  The information contained in this report is based on the provisions of the Income Tax Act (Canada) and
                  the Income Tax Regulations in force at January 1, 2020 (the "Act"). The Act, its judicial
                  interpretation, and the administrative policies of the Canada Revenue Agency (CRA), are subject to
                  change. Any changes to these laws and regulations could impact the information represented in this
                  report.</p>
                <p>
                  IPC Investment Corporation, IPC Securities Corporation and its affiliates assume no liability for any
                  damages that may be incurred by you as a result of relying on the report's content.
                </p>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-close" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>